import styled from "styled-components"
import {mobile}from "../responsive";
import Navbar from "../components/Navbar";
const ParentContainer = styled.div``;

const Container = styled.div`
width: 100vw;
height: calc(100vh - 60px);
background: linear-gradient(
    rgba(255,255,255,0.5),
    rgba(255,255,255,0.5)
),
    url("https://images.pexels.com/photos/6984661/pexels-photo-6984661.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940")
    center;
    background-size: cover;
display: flex;
align-items: center;
justify-content: center;
`;


const Wrapper = styled.div`
padding: 20px;
width: 40%;
background-color: white;
border-radius: 20px;
${mobile({width:"75%",height:"70vh"})};

`;

const Title = styled.h1`
font-size: 24px;
font-weight: 300;
${mobile({fontSize:"15px",fontWeight: "600"})};
`;

const Form = styled.form`
display: flex;
flex-wrap: wrap;
`;


const Input = styled.input`
flex:1;
min-width: 40%;
margin:20px 10px 0px 0px;
padding: 10px;
`;

const Agreement = styled.span`
font-size: 12px;
margin: 20px 0px;
`;

const Button = styled.button`
width: 40%;
border:none;
padding: 15px 20px;
background-color: teal;
color: white;
cursor: pointer;
`;

const Register = () => {
  return (
    <ParentContainer>
    <Navbar/>
    <Container>
        <Wrapper>
            <Title>Sign Up with your Email to get started</Title>
            <Form>
                <Input placeholder="name"/>
                <Input placeholder="last name"/>
                <Input placeholder="username"/>
                <Input placeholder="email"/>
                <Input placeholder="password"/>
                <Input placeholder="confirm password"/>
                <Agreement>BY creating an account, I consent to the processing of my personal data in accordance with the <b>PRIVACY POLICY</b></Agreement>
                <Button>Create</Button>
            </Form>
        </Wrapper>
    </Container>
    </ParentContainer>
  )
}

export default Register